<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="实际销量"
      :innerHeight="540"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      :showFooter="false"
    >
      <el-table
        stripe
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="actualSaleList"
        :default-sort="{ prop: 'value', order: 'descending'}"
      >
        <el-table-column label="店铺/个数" prop="storeName" show-overflow-tooltip></el-table-column>
        <el-table-column label="累计销量" prop="value" show-overflow-tooltip></el-table-column>
        <el-table-column label="是否A类" prop="isAclass" show-overflow-tooltip></el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  data() {
    return {
      dialogVisible: false,
      tableData: []
    }
  },
  computed: {
    actualSaleList() {
      const mapStores = {
        jdzyc: "京东自营厂", 
        jd1: "京东一店", 
        jd2: "京东二店", 
        jpd: "精品店", 
        mnzyc: "猫宁自营厂", 
        pdd: "拼多多", 
        snd: "苏宁店", 
        snzyc: "苏宁自营厂", 
        tm1: "天猫一店", 
        tm2: "天猫二店", 
        wph: "唯品会", 
        zmd: "专卖店"
      }
      if(this.data) {
        let {
          jdzyc,
          jd1,
          jd2,
          jpd,
          mnzyc,
          pdd,
          snd,
          snzyc,
          tm1,
          tm2,
          wph,
          zmd,
        } = this.data;
        let stores = {
          jdzyc,
          jd1,
          jd2,
          jpd,
          mnzyc,
          pdd,
          snd,
          snzyc,
          tm1,
          tm2,
          wph,
          zmd,
        }
        let arr = [];
        Object.keys(stores).forEach(key=>{
          arr.push({
            storeName: mapStores[key],
            value: +stores[key],
            isAclass: ''
          })
        })
        arr = arr.map(v=>{
          return {
            ...v,
            isAclass: this.data['storeName'].includes(v['storeName']) ? '是' : '否'
          }
        })
        return arr;
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.updateVal();
    }
  }
}
</script>

<style>

</style>